export default __webpack_public_path__ + "static/media/TIENLEN_HISTORY_MOBILE-VIE.0d05bf59.jpg";